import Layout from '@/layout'

const jdRouter = [
    {
        path: '/putTools',
        name: 'putTools',
        component: () => import('@/layout/'),
        meta: {
            title: '投放工具',
            hasChildrenMenu: true,
            // redirect: '/recommend/homeLog/operatingRecord',
        },
        children: [

            {
                path: 'jdCommodityFunction',
                name: 'jdCommodityFunction',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '商品功能',
                    hasChildrenMenu: true,
                    icon:'iconshangpin1'
                },
                children:[
                    {
                        path: 'jdBatchInferior',
                        name: 'jdBatchInferior',
                        component: () => import('@/views/putTools/jdBatchInferior/'),
                        meta: {title: '批量下品',icon: 'iconrizhijiankong'},

                    },

                    {
                        path: 'jdBatchResulted',
                        name: 'jdBatchResulted',
                        component: () => import('@/views/putTools/jdBatchResulted/'),
                        meta: {title: '批量上品'},
                    },
                    // jdBatchWord
                    {
                        path: 'jdBatchWord',
                        name: 'jdBatchWord',
                        component: () => import('@/views/putTools/jdBatchWord/'),
                        meta: {title: '批量下词'},
                    },
                    {
                        path: 'jdBatchAddWord',
                        name: 'jdBatchAddWord',
                        component: () => import('@/views/putTools/jdBatchAddWord/'),
                        meta: {title: '批量上词'},
                    }
                ]
            },





        ]

    },
]


export default jdRouter



// WEBPACK FOOTER //
// ./src/router/jd.js